import { useState } from "react";
import { putDataWithMethodOverride, putData as apiPutData } from "../../services/api";

const usePut = (endpoint, initialData = {}) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const putData = async (id = '', putData, useFormData = false, useMethodOverride = true) => {
    setLoading(true);
    try {
      const response = useMethodOverride
        ? await putDataWithMethodOverride(endpoint, id, putData, useFormData)
        : await apiPutData(endpoint, id, putData, useFormData);
      setData(response.data);
      setError(null)
    } catch (err) {
      setError(err);
      throw err
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, putData, setError };
};

export default usePut;